import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import { APIUserRoleMembershipDelete,APIUserRoleMembershipGetList, APIUserRoleMembershipPost } from './UserRoleMemberships.api';

export const fetchUserRoleMemberships = createAsyncThunk('users/fetchUserRoleMembershipList', async (params: {tenantId: string, userId: string, signal?: AbortSignal}) => {
    const response = await APIUserRoleMembershipGetList(params);
    return _formatUserRoleMembershipResponse(response.data);
});

export const deleteUserRoleMembership = createAsyncThunk('users/deleteUserRoleMembership', async (item: {tenantId: string, userId: string, roleId: string})=> {
    const response = await APIUserRoleMembershipDelete(item);
    const rows = await handleListFetch(APIUserRoleMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    const formattedData = _formatUserRoleMembershipResponse(rows);
    return {
        response,
        formattedData
    };
});

export const postUserRoleMembership = createAsyncThunk('users/postUserRoleMembership', async (item: {
    tenantId: string,
    roleId: string,
    userId: string
}) => {
    const response = await APIUserRoleMembershipPost(item);
    const rows = await handleListFetch(APIUserRoleMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    return {
        response,
        rows: _formatUserRoleMembershipResponse(rows)
    };
});

const _formatUserRoleMembershipResponse = (rows: {
    roleId: string;
    userId: string;
    roleName: string;
}[]) => {
    return rows.map(item => ({
        ...item,
        id: `${item.roleId}`
    }));
};
